module.exports = __webpack_public_path__ + "img/11.fa03b4ae.jpg";